import { AfterViewInit, Component, inject, OnInit } from "@angular/core";
import { LoadingService } from "../services/loading.service";
import { OfflineBaseComponent } from "./offline-base.component";

@Component({
    template: ''
})
export class LoadingBaseComponent extends OfflineBaseComponent implements OnInit, AfterViewInit {
    private loading: LoadingService;
    private needEnd: boolean = false;
    constructor() {
        super();

        this.loading = inject(LoadingService);

    }
    ngOnInit(): void {
        this.needEnd = this.loading.start('loading base');
    }
    ngAfterViewInit(): void {
        if (this.needEnd) {
            this.loading.end('loading base');
        }
    }
}